import { Award, Globe } from 'lucide-react';
import type { FC } from 'react';
import isoImages from '../../images/iso-images.svg';
import makeInIndia from '../../images/Make_In_India.png';

const TrustBar: FC = () => (
  <div className="pre-footer__trust">
    <div className="pre-footer__container pre-footer__trust-inner">
      <div className="pre-footer__trust-logos">
        <img
          alt="ISO 9001, ISO 14001, ISO 45001, and ISO 50001 certified company"
          className="pre-footer__iso-images"
          height={99}
          src={isoImages}
          width={395}
        />

        <img
          alt="Make in India"
          className="pre-footer__make-in-india"
          height={72}
          src={makeInIndia}
          width={72}
        />
      </div>

      <div className="pre-footer__trust-items">
        <p className="pre-footer__trust-item">
          <Globe aria-hidden className="pre-footer__trust-icon" size={22} strokeWidth={1.75} />
          <span>GLOBAL SUPPORT EXCELLENCE</span>
        </p>
        <p className="pre-footer__trust-item">
          <Award aria-hidden className="pre-footer__trust-icon" size={22} strokeWidth={1.75} />
          <span>65+ YEARS OF PRECISION</span>
        </p>
      </div>
    </div>
  </div>
);

export default TrustBar;
